/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ActivateCollectorLicense201Response,
    ActivateCollectorLicense201ResponseFromJSON,
    ActivateCollectorLicense201ResponseToJSON,
} from '../models/ActivateCollectorLicense201Response';
import {
    type ActivateCollectorLicense403Response,
    ActivateCollectorLicense403ResponseFromJSON,
    ActivateCollectorLicense403ResponseToJSON,
} from '../models/ActivateCollectorLicense403Response';
import {
    type ActivateCollectorLicense500Response,
    ActivateCollectorLicense500ResponseFromJSON,
    ActivateCollectorLicense500ResponseToJSON,
} from '../models/ActivateCollectorLicense500Response';
import {
    type ActivateCollectorLicenseRequest,
    ActivateCollectorLicenseRequestFromJSON,
    ActivateCollectorLicenseRequestToJSON,
} from '../models/ActivateCollectorLicenseRequest';
import {
    type AddClientTeamMember200Response,
    AddClientTeamMember200ResponseFromJSON,
    AddClientTeamMember200ResponseToJSON,
} from '../models/AddClientTeamMember200Response';
import {
    type AddClientTeamMemberRequest,
    AddClientTeamMemberRequestFromJSON,
    AddClientTeamMemberRequestToJSON,
} from '../models/AddClientTeamMemberRequest';
import {
    type CheckUpdate200Response,
    CheckUpdate200ResponseFromJSON,
    CheckUpdate200ResponseToJSON,
} from '../models/CheckUpdate200Response';
import {
    type CreateClientAsAdmin201Response,
    CreateClientAsAdmin201ResponseFromJSON,
    CreateClientAsAdmin201ResponseToJSON,
} from '../models/CreateClientAsAdmin201Response';
import {
    type CreateClientRequest,
    CreateClientRequestFromJSON,
    CreateClientRequestToJSON,
} from '../models/CreateClientRequest';
import {
    type CreateNewQuickcheckClientRequest,
    CreateNewQuickcheckClientRequestFromJSON,
    CreateNewQuickcheckClientRequestToJSON,
} from '../models/CreateNewQuickcheckClientRequest';
import {
    type CreateSupportRequest400Response,
    CreateSupportRequest400ResponseFromJSON,
    CreateSupportRequest400ResponseToJSON,
} from '../models/CreateSupportRequest400Response';
import {
    type DeleteReseller200Response,
    DeleteReseller200ResponseFromJSON,
    DeleteReseller200ResponseToJSON,
} from '../models/DeleteReseller200Response';
import {
    type GetAllIoes200Response,
    GetAllIoes200ResponseFromJSON,
    GetAllIoes200ResponseToJSON,
} from '../models/GetAllIoes200Response';
import {
    type GetClientInfo200Response,
    GetClientInfo200ResponseFromJSON,
    GetClientInfo200ResponseToJSON,
} from '../models/GetClientInfo200Response';
import {
    type GetClientLicense200Response,
    GetClientLicense200ResponseFromJSON,
    GetClientLicense200ResponseToJSON,
} from '../models/GetClientLicense200Response';
import {
    type GetClientMonthlyReportSettings200Response,
    GetClientMonthlyReportSettings200ResponseFromJSON,
    GetClientMonthlyReportSettings200ResponseToJSON,
} from '../models/GetClientMonthlyReportSettings200Response';
import {
    type GetClientTeam200ResponseInner,
    GetClientTeam200ResponseInnerFromJSON,
    GetClientTeam200ResponseInnerToJSON,
} from '../models/GetClientTeam200ResponseInner';
import {
    type GetClientTeammember200Response,
    GetClientTeammember200ResponseFromJSON,
    GetClientTeammember200ResponseToJSON,
} from '../models/GetClientTeammember200Response';
import {
    type GetCollectorHealthStatus200Response,
    GetCollectorHealthStatus200ResponseFromJSON,
    GetCollectorHealthStatus200ResponseToJSON,
} from '../models/GetCollectorHealthStatus200Response';
import {
    type GetCollectorLicense200Response,
    GetCollectorLicense200ResponseFromJSON,
    GetCollectorLicense200ResponseToJSON,
} from '../models/GetCollectorLicense200Response';
import {
    type GetCollectorLicense401Response,
    GetCollectorLicense401ResponseFromJSON,
    GetCollectorLicense401ResponseToJSON,
} from '../models/GetCollectorLicense401Response';
import {
    type GetCollectorLicense404Response,
    GetCollectorLicense404ResponseFromJSON,
    GetCollectorLicense404ResponseToJSON,
} from '../models/GetCollectorLicense404Response';
import {
    type GetCollectorLicense500Response,
    GetCollectorLicense500ResponseFromJSON,
    GetCollectorLicense500ResponseToJSON,
} from '../models/GetCollectorLicense500Response';
import {
    type GetContactDetails200Response,
    GetContactDetails200ResponseFromJSON,
    GetContactDetails200ResponseToJSON,
} from '../models/GetContactDetails200Response';
import {
    type GetEntraConsentLink200Response,
    GetEntraConsentLink200ResponseFromJSON,
    GetEntraConsentLink200ResponseToJSON,
} from '../models/GetEntraConsentLink200Response';
import {
    type GetEntraConsentLinkRequest,
    GetEntraConsentLinkRequestFromJSON,
    GetEntraConsentLinkRequestToJSON,
} from '../models/GetEntraConsentLinkRequest';
import {
    type GetEntraMeta200Response,
    GetEntraMeta200ResponseFromJSON,
    GetEntraMeta200ResponseToJSON,
} from '../models/GetEntraMeta200Response';
import {
    type GetEntraSyncStatus200Response,
    GetEntraSyncStatus200ResponseFromJSON,
    GetEntraSyncStatus200ResponseToJSON,
} from '../models/GetEntraSyncStatus200Response';
import {
    type GetInstallerLicense200Response,
    GetInstallerLicense200ResponseFromJSON,
    GetInstallerLicense200ResponseToJSON,
} from '../models/GetInstallerLicense200Response';
import {
    type GetInstallerLicense401Response,
    GetInstallerLicense401ResponseFromJSON,
    GetInstallerLicense401ResponseToJSON,
} from '../models/GetInstallerLicense401Response';
import {
    type GetInstallerLicense404Response,
    GetInstallerLicense404ResponseFromJSON,
    GetInstallerLicense404ResponseToJSON,
} from '../models/GetInstallerLicense404Response';
import {
    type GetInstallerLicense500Response,
    GetInstallerLicense500ResponseFromJSON,
    GetInstallerLicense500ResponseToJSON,
} from '../models/GetInstallerLicense500Response';
import {
    type GetIoeContent200Response,
    GetIoeContent200ResponseFromJSON,
    GetIoeContent200ResponseToJSON,
} from '../models/GetIoeContent200Response';
import {
    type GetWellKnownEmailServices401Response,
    GetWellKnownEmailServices401ResponseFromJSON,
    GetWellKnownEmailServices401ResponseToJSON,
} from '../models/GetWellKnownEmailServices401Response';
import {
    type GetWellKnownEmailServices500Response,
    GetWellKnownEmailServices500ResponseFromJSON,
    GetWellKnownEmailServices500ResponseToJSON,
} from '../models/GetWellKnownEmailServices500Response';
import {
    type InitialScanRequest,
    InitialScanRequestFromJSON,
    InitialScanRequestToJSON,
} from '../models/InitialScanRequest';
import {
    type RemoveClientTeamMemberRequest,
    RemoveClientTeamMemberRequestFromJSON,
    RemoveClientTeamMemberRequestToJSON,
} from '../models/RemoveClientTeamMemberRequest';
import {
    type SaveEntraMetaRequest,
    SaveEntraMetaRequestFromJSON,
    SaveEntraMetaRequestToJSON,
} from '../models/SaveEntraMetaRequest';
import {
    type SendClientMonthlyReportRequest,
    SendClientMonthlyReportRequestFromJSON,
    SendClientMonthlyReportRequestToJSON,
} from '../models/SendClientMonthlyReportRequest';
import {
    type SetClientRefRequest,
    SetClientRefRequestFromJSON,
    SetClientRefRequestToJSON,
} from '../models/SetClientRefRequest';
import {
    type SetContactDetailsRequest,
    SetContactDetailsRequestFromJSON,
    SetContactDetailsRequestToJSON,
} from '../models/SetContactDetailsRequest';
import {
    type SetEmployeeCountRequest,
    SetEmployeeCountRequestFromJSON,
    SetEmployeeCountRequestToJSON,
} from '../models/SetEmployeeCountRequest';
import {
    type UpdateIoeExceptionRequest,
    UpdateIoeExceptionRequestFromJSON,
    UpdateIoeExceptionRequestToJSON,
} from '../models/UpdateIoeExceptionRequest';
import {
    type UpdateIoeRequest,
    UpdateIoeRequestFromJSON,
    UpdateIoeRequestToJSON,
} from '../models/UpdateIoeRequest';

export interface ActivateCollectorLicenseOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    activateCollectorLicenseRequest: ActivateCollectorLicenseRequest;
}

export interface AddClientTeamMemberOperationRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * 
     */
    addClientTeamMemberRequest: AddClientTeamMemberRequest;
}

export interface CalculateSecurityScoreRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface CancelSubscriptionRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface CheckUpdateRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface CreateClientOperationRequest {
    /**
     * 
     */
    createClientRequest: CreateClientRequest;
}

export interface CreateNewQuickcheckClientOperationRequest {
    /**
     * 
     */
    createNewQuickcheckClientRequest: CreateNewQuickcheckClientRequest;
}

export interface DisconnectAdRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface DisconnectEntraRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface DownloadPubCertRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface ExportIoeFindingsCSVRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface ExportSingleIoeFindingsCSVRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * IoE check identifier (e.g. `user-password-never-expires`).
     */
    ioeId: string;
}

export interface GetAllIoesRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetClientInfoRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetClientLicenseRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetClientMonthlyReportRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * Month of the report as `YYYY-MM`, must not be in the future. Defaults to the previous month.
     */
    month?: string;
    /**
     * File format of the report.
     */
    format?: GetClientMonthlyReportFormatEnum;
}

export interface GetClientMonthlyReportSettingsRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetClientReportRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetClientTeamRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetClientTeammemberRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * Keycloak user UUID of the team member.
     */
    userUUID: string;
}

export interface GetCollectorAuditStatusRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface GetCollectorConfigRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface GetCollectorHealthStatusRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetCollectorLicenseRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    activateCollectorLicenseRequest: ActivateCollectorLicenseRequest;
}

export interface GetCollectorSbomRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * Executable the SBOM describes.
     */
    component?: GetCollectorSbomComponentEnum;
}

export interface GetContactDetailsRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetEntraConsentLinkOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    getEntraConsentLinkRequest: GetEntraConsentLinkRequest;
}

export interface GetEntraMetaRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetEntraSyncStatusRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetInstallerRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetInstallerLicenseRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetIoeContentRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * IoE check identifier (e.g. `user-password-never-expires`).
     */
    ioeId: string;
}

export interface GetQuickcheckInstallerRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface GetVersionRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface InitialScanOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    initialScanRequest: InitialScanRequest;
}

export interface RemoveClientTeamMemberOperationRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * 
     */
    removeClientTeamMemberRequest: RemoveClientTeamMemberRequest;
}

export interface ReportCollectorDataChangeRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface RescanIoesRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface ResetCollectorAuditStatusRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface ResetIoaThresholdsRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface ResetIoeCriticalitiesRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface ResetIoeThresholdsRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

export interface ResignCollectorConfigRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface SaveEntraMetaOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    saveEntraMetaRequest: SaveEntraMetaRequest;
}

export interface SendClientMonthlyReportOperationRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * 
     */
    sendClientMonthlyReportRequest: SendClientMonthlyReportRequest;
}

export interface SendFileLogRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    logName: string;
}

export interface SetClientRefOperationRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * 
     */
    setClientRefRequest: SetClientRefRequest;
}

export interface SetContactDetailsOperationRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * 
     */
    setContactDetailsRequest: SetContactDetailsRequest;
}

export interface SetEmployeeCountOperationRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * 
     */
    setEmployeeCountRequest: SetEmployeeCountRequest;
}

export interface UpdateClientMonthlyReportSettingsRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * 
     */
    getClientMonthlyReportSettings200Response: GetClientMonthlyReportSettings200Response;
}

export interface UpdateIoeOperationRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * UUID of the IoE finding to update.
     */
    ioeId: string;
    /**
     * 
     */
    updateIoeRequest: UpdateIoeRequest;
}

export interface UpdateIoeExceptionOperationRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
    /**
     * Identifier of the IoE check (e.g. `domain-ldap-signing-not-required`).
     */
    ioeKey: UpdateIoeExceptionOperationIoeKeyEnum;
    /**
     * 
     */
    updateIoeExceptionRequest: UpdateIoeExceptionRequest;
}

export interface ValidateEntraConnectionRequest {
    /**
     * UUID of the client.
     */
    clientUUID: string;
}

/**
 * 
 */
export class ClientApi extends runtime.BaseAPI {

    /**
     * Creates request options for activateCollectorLicense without sending the request
     */
    async activateCollectorLicenseRequestOpts(requestParameters: ActivateCollectorLicenseOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling activateCollectorLicense().'
            );
        }

        if (requestParameters['activateCollectorLicenseRequest'] == null) {
            throw new runtime.RequiredError(
                'activateCollectorLicenseRequest',
                'Required parameter "activateCollectorLicenseRequest" was null or undefined when calling activateCollectorLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuthCollector authentication
        }


        let urlPath = `/client/{clientUUID}/collector/license/activate`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActivateCollectorLicenseRequestToJSON(requestParameters['activateCollectorLicenseRequest']),
        };
    }

    /**
     * Get client license with data for collector
     */
    async activateCollectorLicenseRaw(requestParameters: ActivateCollectorLicenseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivateCollectorLicense201Response>> {
        const requestOptions = await this.activateCollectorLicenseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivateCollectorLicense201ResponseFromJSON(jsonValue));
    }

    /**
     * Get client license with data for collector
     */
    async activateCollectorLicense(clientUUID: string, activateCollectorLicenseRequest: ActivateCollectorLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivateCollectorLicense201Response> {
        const response = await this.activateCollectorLicenseRaw({ clientUUID: clientUUID, activateCollectorLicenseRequest: activateCollectorLicenseRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addClientTeamMember without sending the request
     */
    async addClientTeamMemberRequestOpts(requestParameters: AddClientTeamMemberOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling addClientTeamMember().'
            );
        }

        if (requestParameters['addClientTeamMemberRequest'] == null) {
            throw new runtime.RequiredError(
                'addClientTeamMemberRequest',
                'Required parameter "addClientTeamMemberRequest" was null or undefined when calling addClientTeamMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/collaboration/team`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddClientTeamMemberRequestToJSON(requestParameters['addClientTeamMemberRequest']),
        };
    }

    /**
     * Adds a new member to this client\'s team. A Keycloak account is created and the user receives an invitation email to set their password.
     * Add team member
     */
    async addClientTeamMemberRaw(requestParameters: AddClientTeamMemberOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddClientTeamMember200Response>> {
        const requestOptions = await this.addClientTeamMemberRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddClientTeamMember200ResponseFromJSON(jsonValue));
    }

    /**
     * Adds a new member to this client\'s team. A Keycloak account is created and the user receives an invitation email to set their password.
     * Add team member
     */
    async addClientTeamMember(clientUUID: string, addClientTeamMemberRequest: AddClientTeamMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddClientTeamMember200Response> {
        const response = await this.addClientTeamMemberRaw({ clientUUID: clientUUID, addClientTeamMemberRequest: addClientTeamMemberRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for calculateSecurityScore without sending the request
     */
    async calculateSecurityScoreRequestOpts(requestParameters: CalculateSecurityScoreRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling calculateSecurityScore().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/ioe/security-score`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Triggers an immediate recalculation of the security score for this client based on current active IoE findings.
     * Recalculate security score
     */
    async calculateSecurityScoreRaw(requestParameters: CalculateSecurityScoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.calculateSecurityScoreRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Triggers an immediate recalculation of the security score for this client based on current active IoE findings.
     * Recalculate security score
     */
    async calculateSecurityScore(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.calculateSecurityScoreRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for cancelSubscription without sending the request
     */
    async cancelSubscriptionRequestOpts(requestParameters: CancelSubscriptionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling cancelSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/license/cancel`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Cancels the active subscription for this client. The subscription remains active until the end of the current billing period.
     * Cancel client subscription
     */
    async cancelSubscriptionRaw(requestParameters: CancelSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.cancelSubscriptionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Cancels the active subscription for this client. The subscription remains active until the end of the current billing period.
     * Cancel client subscription
     */
    async cancelSubscription(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.cancelSubscriptionRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for checkUpdate without sending the request
     */
    async checkUpdateRequestOpts(requestParameters: CheckUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling checkUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuthCollector authentication
        }


        let urlPath = `/client/{clientUUID}/collector/update`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Check if there is an update available for the collector
     */
    async checkUpdateRaw(requestParameters: CheckUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckUpdate200Response>> {
        const requestOptions = await this.checkUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckUpdate200ResponseFromJSON(jsonValue));
    }

    /**
     * Check if there is an update available for the collector
     */
    async checkUpdate(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckUpdate200Response> {
        const response = await this.checkUpdateRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createClient without sending the request
     */
    async createClientRequestOpts(requestParameters: CreateClientOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createClientRequest'] == null) {
            throw new runtime.RequiredError(
                'createClientRequest',
                'Required parameter "createClientRequest" was null or undefined when calling createClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/new`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClientRequestToJSON(requestParameters['createClientRequest']),
        };
    }

    /**
     * Create a new client
     */
    async createClientRaw(requestParameters: CreateClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAsAdmin201Response>> {
        const requestOptions = await this.createClientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAsAdmin201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new client
     */
    async createClient(createClientRequest: CreateClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAsAdmin201Response> {
        const response = await this.createClientRaw({ createClientRequest: createClientRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createNewQuickcheckClient without sending the request
     */
    async createNewQuickcheckClientRequestOpts(requestParameters: CreateNewQuickcheckClientOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createNewQuickcheckClientRequest'] == null) {
            throw new runtime.RequiredError(
                'createNewQuickcheckClientRequest',
                'Required parameter "createNewQuickcheckClientRequest" was null or undefined when calling createNewQuickcheckClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/quickcheck/new`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateNewQuickcheckClientRequestToJSON(requestParameters['createNewQuickcheckClientRequest']),
        };
    }

    /**
     * Create new quickcheck client
     */
    async createNewQuickcheckClientRaw(requestParameters: CreateNewQuickcheckClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.createNewQuickcheckClientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Create new quickcheck client
     */
    async createNewQuickcheckClient(createNewQuickcheckClientRequest: CreateNewQuickcheckClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.createNewQuickcheckClientRaw({ createNewQuickcheckClientRequest: createNewQuickcheckClientRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for disconnectAd without sending the request
     */
    async disconnectAdRequestOpts(requestParameters: DisconnectAdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling disconnectAd().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/collector/ad`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Disconnects the on-premises Active Directory for this client, the counterpart to disconnecting Entra ID. Only possible once the collector has been uninstalled (no data for 24 hours, otherwise 409). Retains all previously collected objects. On-premises logons are no longer frozen at the last collector sync, so on-premises users stop being billable once their last logon is older than 90 days. Reinstalling the collector connects the AD again.
     * Disconnect on-premises Active Directory
     */
    async disconnectAdRaw(requestParameters: DisconnectAdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.disconnectAdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Disconnects the on-premises Active Directory for this client, the counterpart to disconnecting Entra ID. Only possible once the collector has been uninstalled (no data for 24 hours, otherwise 409). Retains all previously collected objects. On-premises logons are no longer frozen at the last collector sync, so on-premises users stop being billable once their last logon is older than 90 days. Reinstalling the collector connects the AD again.
     * Disconnect on-premises Active Directory
     */
    async disconnectAd(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.disconnectAdRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for disconnectEntra without sending the request
     */
    async disconnectEntraRequestOpts(requestParameters: DisconnectEntraRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling disconnectEntra().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/entra/data`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Disconnects the Entra ID (Azure AD) integration for this client. Stops the sync and clears the credentials, but retains all previously synced objects.
     * Disconnect Entra ID integration
     */
    async disconnectEntraRaw(requestParameters: DisconnectEntraRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.disconnectEntraRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Disconnects the Entra ID (Azure AD) integration for this client. Stops the sync and clears the credentials, but retains all previously synced objects.
     * Disconnect Entra ID integration
     */
    async disconnectEntra(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.disconnectEntraRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for downloadPubCert without sending the request
     */
    async downloadPubCertRequestOpts(requestParameters: DownloadPubCertRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling downloadPubCert().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/entra/certificate/public`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Download public entra cert
     */
    async downloadPubCertRaw(requestParameters: DownloadPubCertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.downloadPubCertRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Download public entra cert
     */
    async downloadPubCert(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.downloadPubCertRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Creates request options for exportIoeFindingsCSV without sending the request
     */
    async exportIoeFindingsCSVRequestOpts(requestParameters: ExportIoeFindingsCSVRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling exportIoeFindingsCSV().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/ioe/export/csv`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Exports all active IoE findings for this client as a CSV file download. The file includes all IoE check types and their associated affected objects.
     * Export IoE findings as CSV
     */
    async exportIoeFindingsCSVRaw(requestParameters: ExportIoeFindingsCSVRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.exportIoeFindingsCSVRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Exports all active IoE findings for this client as a CSV file download. The file includes all IoE check types and their associated affected objects.
     * Export IoE findings as CSV
     */
    async exportIoeFindingsCSV(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.exportIoeFindingsCSVRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for exportSingleIoeFindingsCSV without sending the request
     */
    async exportSingleIoeFindingsCSVRequestOpts(requestParameters: ExportSingleIoeFindingsCSVRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling exportSingleIoeFindingsCSV().'
            );
        }

        if (requestParameters['ioeId'] == null) {
            throw new runtime.RequiredError(
                'ioeId',
                'Required parameter "ioeId" was null or undefined when calling exportSingleIoeFindingsCSV().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/ioe/{ioeId}/export/csv`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));
        urlPath = urlPath.replace('{ioeId}', encodeURIComponent(String(requestParameters['ioeId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Exports all findings for a specific IoE check type as a CSV file download.
     * Export single IoE findings as CSV
     */
    async exportSingleIoeFindingsCSVRaw(requestParameters: ExportSingleIoeFindingsCSVRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.exportSingleIoeFindingsCSVRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Exports all findings for a specific IoE check type as a CSV file download.
     * Export single IoE findings as CSV
     */
    async exportSingleIoeFindingsCSV(clientUUID: string, ioeId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.exportSingleIoeFindingsCSVRaw({ clientUUID: clientUUID, ioeId: ioeId }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllIoes without sending the request
     */
    async getAllIoesRequestOpts(requestParameters: GetAllIoesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getAllIoes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/ioe/states`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns all Indicator of Exposure (IoE) checks configured for this client, including their current status, finding counts, and client-specific settings.
     * List all IoEs
     */
    async getAllIoesRaw(requestParameters: GetAllIoesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllIoes200Response>> {
        const requestOptions = await this.getAllIoesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllIoes200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns all Indicator of Exposure (IoE) checks configured for this client, including their current status, finding counts, and client-specific settings.
     * List all IoEs
     */
    async getAllIoes(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllIoes200Response> {
        const response = await this.getAllIoesRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getClientInfo without sending the request
     */
    async getClientInfoRequestOpts(requestParameters: GetClientInfoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getClientInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns configuration and status information for this client, including operating mode, current security score, and the associated serviceprovider.
     * Get client info
     */
    async getClientInfoRaw(requestParameters: GetClientInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClientInfo200Response>> {
        const requestOptions = await this.getClientInfoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClientInfo200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns configuration and status information for this client, including operating mode, current security score, and the associated serviceprovider.
     * Get client info
     */
    async getClientInfo(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClientInfo200Response> {
        const response = await this.getClientInfoRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getClientLicense without sending the request
     */
    async getClientLicenseRequestOpts(requestParameters: GetClientLicenseRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getClientLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/license`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the current license and subscription details for this client.
     * Get client license
     */
    async getClientLicenseRaw(requestParameters: GetClientLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClientLicense200Response>> {
        const requestOptions = await this.getClientLicenseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClientLicense200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the current license and subscription details for this client.
     * Get client license
     */
    async getClientLicense(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClientLicense200Response> {
        const response = await this.getClientLicenseRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getClientMonthlyReport without sending the request
     */
    async getClientMonthlyReportRequestOpts(requestParameters: GetClientMonthlyReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getClientMonthlyReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        if (requestParameters['format'] != null) {
            queryParameters['format'] = requestParameters['format'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/report/monthly`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Creates the activity report of one calendar month (Europe/Berlin) for this client: new and resolved findings, security score trend, documented exceptions, IoA events, changes to identities and privileged groups, monitoring availability and the current status. `format=pdf` returns the formatted report, `format=csv` every event of the month as one row (semicolon separated).
     * Download monthly activity report
     */
    async getClientMonthlyReportRaw(requestParameters: GetClientMonthlyReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.getClientMonthlyReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates the activity report of one calendar month (Europe/Berlin) for this client: new and resolved findings, security score trend, documented exceptions, IoA events, changes to identities and privileged groups, monitoring availability and the current status. `format=pdf` returns the formatted report, `format=csv` every event of the month as one row (semicolon separated).
     * Download monthly activity report
     */
    async getClientMonthlyReport(clientUUID: string, month?: string, format?: GetClientMonthlyReportFormatEnum, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getClientMonthlyReportRaw({ clientUUID: clientUUID, month: month, format: format }, initOverrides);
    }

    /**
     * Creates request options for getClientMonthlyReportSettings without sending the request
     */
    async getClientMonthlyReportSettingsRequestOpts(requestParameters: GetClientMonthlyReportSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getClientMonthlyReportSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/report/monthly/settings`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns whether the monthly activity report is mailed automatically and to which addresses.
     * Get monthly report settings
     */
    async getClientMonthlyReportSettingsRaw(requestParameters: GetClientMonthlyReportSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClientMonthlyReportSettings200Response>> {
        const requestOptions = await this.getClientMonthlyReportSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClientMonthlyReportSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns whether the monthly activity report is mailed automatically and to which addresses.
     * Get monthly report settings
     */
    async getClientMonthlyReportSettings(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClientMonthlyReportSettings200Response> {
        const response = await this.getClientMonthlyReportSettingsRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getClientReport without sending the request
     */
    async getClientReportRequestOpts(requestParameters: GetClientReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getClientReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/report`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Downloads the latest generated security report for this client as a PDF file.
     * Download security report
     */
    async getClientReportRaw(requestParameters: GetClientReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.getClientReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Downloads the latest generated security report for this client as a PDF file.
     * Download security report
     */
    async getClientReport(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getClientReportRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Creates request options for getClientTeam without sending the request
     */
    async getClientTeamRequestOpts(requestParameters: GetClientTeamRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getClientTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/collaboration/team`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns all team members of this client.
     * List team members
     */
    async getClientTeamRaw(requestParameters: GetClientTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetClientTeam200ResponseInner>>> {
        const requestOptions = await this.getClientTeamRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetClientTeam200ResponseInnerFromJSON));
    }

    /**
     * Returns all team members of this client.
     * List team members
     */
    async getClientTeam(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetClientTeam200ResponseInner>> {
        const response = await this.getClientTeamRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getClientTeammember without sending the request
     */
    async getClientTeammemberRequestOpts(requestParameters: GetClientTeammemberRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getClientTeammember().'
            );
        }

        if (requestParameters['userUUID'] == null) {
            throw new runtime.RequiredError(
                'userUUID',
                'Required parameter "userUUID" was null or undefined when calling getClientTeammember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/collaboration/team/member/{userUUID}`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));
        urlPath = urlPath.replace('{userUUID}', encodeURIComponent(String(requestParameters['userUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the profile of a single team member of this client.
     * Get team member
     */
    async getClientTeammemberRaw(requestParameters: GetClientTeammemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClientTeammember200Response>> {
        const requestOptions = await this.getClientTeammemberRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClientTeammember200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the profile of a single team member of this client.
     * Get team member
     */
    async getClientTeammember(clientUUID: string, userUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClientTeammember200Response> {
        const response = await this.getClientTeammemberRaw({ clientUUID: clientUUID, userUUID: userUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCollectorAuditStatus without sending the request
     */
    async getCollectorAuditStatusRequestOpts(requestParameters: GetCollectorAuditStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getCollectorAuditStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuthCollector authentication
        }


        let urlPath = `/client/{clientUUID}/collector/audit/status`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get current audit status as string - displayed during scan
     */
    async getCollectorAuditStatusRaw(requestParameters: GetCollectorAuditStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitialScanRequest>> {
        const requestOptions = await this.getCollectorAuditStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitialScanRequestFromJSON(jsonValue));
    }

    /**
     * Get current audit status as string - displayed during scan
     */
    async getCollectorAuditStatus(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitialScanRequest> {
        const response = await this.getCollectorAuditStatusRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCollectorConfig without sending the request
     */
    async getCollectorConfigRequestOpts(requestParameters: GetCollectorConfigRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getCollectorConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuthCollector authentication
        }


        let urlPath = `/client/{clientUUID}/collector/config`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get collector config to update local .license file
     */
    async getCollectorConfigRaw(requestParameters: GetCollectorConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.getCollectorConfigRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get collector config to update local .license file
     */
    async getCollectorConfig(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getCollectorConfigRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCollectorHealthStatus without sending the request
     */
    async getCollectorHealthStatusRequestOpts(requestParameters: GetCollectorHealthStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getCollectorHealthStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuthCollector authentication
        }


        let urlPath = `/client/{clientUUID}/collector/health`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the current health status of the collector for this client. The collector calls this endpoint on a schedule to determine whether it should restart itself.
     * Get collector health status
     */
    async getCollectorHealthStatusRaw(requestParameters: GetCollectorHealthStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCollectorHealthStatus200Response>> {
        const requestOptions = await this.getCollectorHealthStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCollectorHealthStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the current health status of the collector for this client. The collector calls this endpoint on a schedule to determine whether it should restart itself.
     * Get collector health status
     */
    async getCollectorHealthStatus(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCollectorHealthStatus200Response> {
        const response = await this.getCollectorHealthStatusRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCollectorLicense without sending the request
     */
    async getCollectorLicenseRequestOpts(requestParameters: GetCollectorLicenseRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getCollectorLicense().'
            );
        }

        if (requestParameters['activateCollectorLicenseRequest'] == null) {
            throw new runtime.RequiredError(
                'activateCollectorLicenseRequest',
                'Required parameter "activateCollectorLicenseRequest" was null or undefined when calling getCollectorLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuthCollector authentication
        }


        let urlPath = `/client/{clientUUID}/collector/license`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActivateCollectorLicenseRequestToJSON(requestParameters['activateCollectorLicenseRequest']),
        };
    }

    /**
     * Get client license with data for collector
     */
    async getCollectorLicenseRaw(requestParameters: GetCollectorLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCollectorLicense200Response>> {
        const requestOptions = await this.getCollectorLicenseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCollectorLicense200ResponseFromJSON(jsonValue));
    }

    /**
     * Get client license with data for collector
     */
    async getCollectorLicense(clientUUID: string, activateCollectorLicenseRequest: ActivateCollectorLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCollectorLicense200Response> {
        const response = await this.getCollectorLicenseRaw({ clientUUID: clientUUID, activateCollectorLicenseRequest: activateCollectorLicenseRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCollectorSbom without sending the request
     */
    async getCollectorSbomRequestOpts(requestParameters: GetCollectorSbomRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getCollectorSbom().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['component'] != null) {
            queryParameters['component'] = requestParameters['component'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/collector/sbom`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Downloads the Software Bill of Materials (CycloneDX 1.6 JSON, BSI TR-03183-2) of the collector version installed for this client. `component=collector` (default) returns the SBOM of the collector service, `component=installer` the SBOM of the installer. If no collector has reported a version yet, the SBOM of the currently offered version is returned.
     * Download collector SBOM
     */
    async getCollectorSbomRaw(requestParameters: GetCollectorSbomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.getCollectorSbomRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Downloads the Software Bill of Materials (CycloneDX 1.6 JSON, BSI TR-03183-2) of the collector version installed for this client. `component=collector` (default) returns the SBOM of the collector service, `component=installer` the SBOM of the installer. If no collector has reported a version yet, the SBOM of the currently offered version is returned.
     * Download collector SBOM
     */
    async getCollectorSbom(clientUUID: string, component?: GetCollectorSbomComponentEnum, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCollectorSbomRaw({ clientUUID: clientUUID, component: component }, initOverrides);
    }

    /**
     * Creates request options for getContactDetails without sending the request
     */
    async getContactDetailsRequestOpts(requestParameters: GetContactDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getContactDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/contact`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the client\'s stored admin and emergency contact information.
     * Get contact details
     */
    async getContactDetailsRaw(requestParameters: GetContactDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContactDetails200Response>> {
        const requestOptions = await this.getContactDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContactDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the client\'s stored admin and emergency contact information.
     * Get contact details
     */
    async getContactDetails(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContactDetails200Response> {
        const response = await this.getContactDetailsRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getEntraConsentLink without sending the request
     */
    async getEntraConsentLinkRequestOpts(requestParameters: GetEntraConsentLinkOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getEntraConsentLink().'
            );
        }

        if (requestParameters['getEntraConsentLinkRequest'] == null) {
            throw new runtime.RequiredError(
                'getEntraConsentLinkRequest',
                'Required parameter "getEntraConsentLinkRequest" was null or undefined when calling getEntraConsentLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/entra/consent-link`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetEntraConsentLinkRequestToJSON(requestParameters['getEntraConsentLinkRequest']),
        };
    }

    /**
     * Generate Entra ID multi-tenant admin consent URL
     */
    async getEntraConsentLinkRaw(requestParameters: GetEntraConsentLinkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEntraConsentLink200Response>> {
        const requestOptions = await this.getEntraConsentLinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEntraConsentLink200ResponseFromJSON(jsonValue));
    }

    /**
     * Generate Entra ID multi-tenant admin consent URL
     */
    async getEntraConsentLink(clientUUID: string, getEntraConsentLinkRequest: GetEntraConsentLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEntraConsentLink200Response> {
        const response = await this.getEntraConsentLinkRaw({ clientUUID: clientUUID, getEntraConsentLinkRequest: getEntraConsentLinkRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getEntraMeta without sending the request
     */
    async getEntraMetaRequestOpts(requestParameters: GetEntraMetaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getEntraMeta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/entra/data`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the current Entra ID (Azure AD) integration settings for this client, including the registered application and tenant.
     * Get Entra ID configuration
     */
    async getEntraMetaRaw(requestParameters: GetEntraMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEntraMeta200Response>> {
        const requestOptions = await this.getEntraMetaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEntraMeta200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the current Entra ID (Azure AD) integration settings for this client, including the registered application and tenant.
     * Get Entra ID configuration
     */
    async getEntraMeta(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEntraMeta200Response> {
        const response = await this.getEntraMetaRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getEntraSyncStatus without sending the request
     */
    async getEntraSyncStatusRequestOpts(requestParameters: GetEntraSyncStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getEntraSyncStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/entra/sync-status`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns whether the initial Entra ID background sync (triggered after admin consent) is still in progress or has completed.
     * Get Entra ID background sync status
     */
    async getEntraSyncStatusRaw(requestParameters: GetEntraSyncStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEntraSyncStatus200Response>> {
        const requestOptions = await this.getEntraSyncStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEntraSyncStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns whether the initial Entra ID background sync (triggered after admin consent) is still in progress or has completed.
     * Get Entra ID background sync status
     */
    async getEntraSyncStatus(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEntraSyncStatus200Response> {
        const response = await this.getEntraSyncStatusRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getInstaller without sending the request
     */
    async getInstallerRequestOpts(requestParameters: GetInstallerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getInstaller().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/collector/installer`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Downloads the collector installer as a ZIP file pre-configured for this client. The installer is used to deploy the on-premises data collection agent.
     * Download collector installer
     */
    async getInstallerRaw(requestParameters: GetInstallerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.getInstallerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Downloads the collector installer as a ZIP file pre-configured for this client. The installer is used to deploy the on-premises data collection agent.
     * Download collector installer
     */
    async getInstaller(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getInstallerRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Creates request options for getInstallerLicense without sending the request
     */
    async getInstallerLicenseRequestOpts(requestParameters: GetInstallerLicenseRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getInstallerLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/installer/license`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns license and operational mode data used by the collector installer to configure itself on startup.
     * Get installer license
     */
    async getInstallerLicenseRaw(requestParameters: GetInstallerLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInstallerLicense200Response>> {
        const requestOptions = await this.getInstallerLicenseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInstallerLicense200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns license and operational mode data used by the collector installer to configure itself on startup.
     * Get installer license
     */
    async getInstallerLicense(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInstallerLicense200Response> {
        const response = await this.getInstallerLicenseRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getIoeContent without sending the request
     */
    async getIoeContentRequestOpts(requestParameters: GetIoeContentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getIoeContent().'
            );
        }

        if (requestParameters['ioeId'] == null) {
            throw new runtime.RequiredError(
                'ioeId',
                'Required parameter "ioeId" was null or undefined when calling getIoeContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/ioe/{ioeId}/content`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));
        urlPath = urlPath.replace('{ioeId}', encodeURIComponent(String(requestParameters['ioeId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the cached editorial content for a specific IoE check — including a human-readable title and structured FAQ sections (overview, risk details, remediation steps). Content is synced daily.
     * Get IoE content
     */
    async getIoeContentRaw(requestParameters: GetIoeContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetIoeContent200Response>> {
        const requestOptions = await this.getIoeContentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetIoeContent200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the cached editorial content for a specific IoE check — including a human-readable title and structured FAQ sections (overview, risk details, remediation steps). Content is synced daily.
     * Get IoE content
     */
    async getIoeContent(clientUUID: string, ioeId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetIoeContent200Response> {
        const response = await this.getIoeContentRaw({ clientUUID: clientUUID, ioeId: ioeId }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getQuickcheckInstaller without sending the request
     */
    async getQuickcheckInstallerRequestOpts(requestParameters: GetQuickcheckInstallerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getQuickcheckInstaller().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/quickcheck/collector/installer`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Downloads the quickcheck collector installer pre-configured for this client. The link is valid for 3 days after client creation and is typically sent by email.
     * Download quickcheck installer
     */
    async getQuickcheckInstallerRaw(requestParameters: GetQuickcheckInstallerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.getQuickcheckInstallerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Downloads the quickcheck collector installer pre-configured for this client. The link is valid for 3 days after client creation and is typically sent by email.
     * Download quickcheck installer
     */
    async getQuickcheckInstaller(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getQuickcheckInstallerRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Creates request options for getVersion without sending the request
     */
    async getVersionRequestOpts(requestParameters: GetVersionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/collector/version`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Check if there is an update available for the collector in dashboard
     */
    async getVersionRaw(requestParameters: GetVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckUpdate200Response>> {
        const requestOptions = await this.getVersionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckUpdate200ResponseFromJSON(jsonValue));
    }

    /**
     * Check if there is an update available for the collector in dashboard
     */
    async getVersion(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckUpdate200Response> {
        const response = await this.getVersionRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for initialScan without sending the request
     */
    async initialScanRequestOpts(requestParameters: InitialScanOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling initialScan().'
            );
        }

        if (requestParameters['initialScanRequest'] == null) {
            throw new runtime.RequiredError(
                'initialScanRequest',
                'Required parameter "initialScanRequest" was null or undefined when calling initialScan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/collector/initialscan`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitialScanRequestToJSON(requestParameters['initialScanRequest']),
        };
    }

    /**
     * Report status of initial scan
     */
    async initialScanRaw(requestParameters: InitialScanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.initialScanRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Report status of initial scan
     */
    async initialScan(clientUUID: string, initialScanRequest: InitialScanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.initialScanRaw({ clientUUID: clientUUID, initialScanRequest: initialScanRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeClientTeamMember without sending the request
     */
    async removeClientTeamMemberRequestOpts(requestParameters: RemoveClientTeamMemberOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling removeClientTeamMember().'
            );
        }

        if (requestParameters['removeClientTeamMemberRequest'] == null) {
            throw new runtime.RequiredError(
                'removeClientTeamMemberRequest',
                'Required parameter "removeClientTeamMemberRequest" was null or undefined when calling removeClientTeamMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/collaboration/team`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveClientTeamMemberRequestToJSON(requestParameters['removeClientTeamMemberRequest']),
        };
    }

    /**
     * Removes a user from this client\'s team and deletes their Keycloak account.
     * Remove team member
     */
    async removeClientTeamMemberRaw(requestParameters: RemoveClientTeamMemberOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.removeClientTeamMemberRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Removes a user from this client\'s team and deletes their Keycloak account.
     * Remove team member
     */
    async removeClientTeamMember(clientUUID: string, removeClientTeamMemberRequest: RemoveClientTeamMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.removeClientTeamMemberRaw({ clientUUID: clientUUID, removeClientTeamMemberRequest: removeClientTeamMemberRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reportCollectorDataChange without sending the request
     */
    async reportCollectorDataChangeRequestOpts(requestParameters: ReportCollectorDataChangeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling reportCollectorDataChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/collector/sync/data-change`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Notify the backend that the collector detected changes during the last sync cycle, triggering IoE/IoA reevaluation
     */
    async reportCollectorDataChangeRaw(requestParameters: ReportCollectorDataChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.reportCollectorDataChangeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Notify the backend that the collector detected changes during the last sync cycle, triggering IoE/IoA reevaluation
     */
    async reportCollectorDataChange(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.reportCollectorDataChangeRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for rescanIoes without sending the request
     */
    async rescanIoesRequestOpts(requestParameters: RescanIoesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling rescanIoes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/audit/rescan`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Queues an immediate rescan of all IoE checks for this client. The scan runs asynchronously — poll the IoE list to see updated results.
     * Trigger IoE rescan
     */
    async rescanIoesRaw(requestParameters: RescanIoesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.rescanIoesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Queues an immediate rescan of all IoE checks for this client. The scan runs asynchronously — poll the IoE list to see updated results.
     * Trigger IoE rescan
     */
    async rescanIoes(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.rescanIoesRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resetCollectorAuditStatus without sending the request
     */
    async resetCollectorAuditStatusRequestOpts(requestParameters: ResetCollectorAuditStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling resetCollectorAuditStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuthCollector authentication
        }


        let urlPath = `/client/{clientUUID}/collector/audit/status`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Reset audit status to initial state
     */
    async resetCollectorAuditStatusRaw(requestParameters: ResetCollectorAuditStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.resetCollectorAuditStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Reset audit status to initial state
     */
    async resetCollectorAuditStatus(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.resetCollectorAuditStatusRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resetIoaThresholds without sending the request
     */
    async resetIoaThresholdsRequestOpts(requestParameters: ResetIoaThresholdsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling resetIoaThresholds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/ioa/thresholds/reset`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Resets all IoA detection thresholds for this client back to the global defaults. Use this to undo any client-specific sensitivity tuning.
     * Reset IoA thresholds
     */
    async resetIoaThresholdsRaw(requestParameters: ResetIoaThresholdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.resetIoaThresholdsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resets all IoA detection thresholds for this client back to the global defaults. Use this to undo any client-specific sensitivity tuning.
     * Reset IoA thresholds
     */
    async resetIoaThresholds(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetIoaThresholdsRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Creates request options for resetIoeCriticalities without sending the request
     */
    async resetIoeCriticalitiesRequestOpts(requestParameters: ResetIoeCriticalitiesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling resetIoeCriticalities().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/ioe/criticalities/reset`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Resets all IoE criticality overrides for this client back to the global defaults. Use this to undo any client-specific criticality customizations.
     * Reset IoE criticalities
     */
    async resetIoeCriticalitiesRaw(requestParameters: ResetIoeCriticalitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.resetIoeCriticalitiesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resets all IoE criticality overrides for this client back to the global defaults. Use this to undo any client-specific criticality customizations.
     * Reset IoE criticalities
     */
    async resetIoeCriticalities(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetIoeCriticalitiesRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Creates request options for resetIoeThresholds without sending the request
     */
    async resetIoeThresholdsRequestOpts(requestParameters: ResetIoeThresholdsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling resetIoeThresholds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/ioe/thresholds/reset`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Resets all IoE detection thresholds for this client back to the global defaults. Use this to undo any client-specific threshold tuning.
     * Reset IoE thresholds
     */
    async resetIoeThresholdsRaw(requestParameters: ResetIoeThresholdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.resetIoeThresholdsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resets all IoE detection thresholds for this client back to the global defaults. Use this to undo any client-specific threshold tuning.
     * Reset IoE thresholds
     */
    async resetIoeThresholds(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetIoeThresholdsRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Creates request options for resignCollectorConfig without sending the request
     */
    async resignCollectorConfigRequestOpts(requestParameters: ResignCollectorConfigRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling resignCollectorConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/collector/config/resign`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Re-sign the collector license JWT with the current LICENSE_JWT_SECRET and persist it. Call this on each active collector after rotating the secret so the stored JWT stays valid.
     */
    async resignCollectorConfigRaw(requestParameters: ResignCollectorConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.resignCollectorConfigRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Re-sign the collector license JWT with the current LICENSE_JWT_SECRET and persist it. Call this on each active collector after rotating the secret so the stored JWT stays valid.
     */
    async resignCollectorConfig(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.resignCollectorConfigRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for saveEntraMeta without sending the request
     */
    async saveEntraMetaRequestOpts(requestParameters: SaveEntraMetaOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling saveEntraMeta().'
            );
        }

        if (requestParameters['saveEntraMetaRequest'] == null) {
            throw new runtime.RequiredError(
                'saveEntraMetaRequest',
                'Required parameter "saveEntraMetaRequest" was null or undefined when calling saveEntraMeta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/entra/data`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveEntraMetaRequestToJSON(requestParameters['saveEntraMetaRequest']),
        };
    }

    /**
     * Save Entra ID settings
     */
    async saveEntraMetaRaw(requestParameters: SaveEntraMetaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.saveEntraMetaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Save Entra ID settings
     */
    async saveEntraMeta(clientUUID: string, saveEntraMetaRequest: SaveEntraMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveEntraMetaRaw({ clientUUID: clientUUID, saveEntraMetaRequest: saveEntraMetaRequest }, initOverrides);
    }

    /**
     * Creates request options for sendClientMonthlyReport without sending the request
     */
    async sendClientMonthlyReportRequestOpts(requestParameters: SendClientMonthlyReportOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling sendClientMonthlyReport().'
            );
        }

        if (requestParameters['sendClientMonthlyReportRequest'] == null) {
            throw new runtime.RequiredError(
                'sendClientMonthlyReportRequest',
                'Required parameter "sendClientMonthlyReportRequest" was null or undefined when calling sendClientMonthlyReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/report/monthly/send`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendClientMonthlyReportRequestToJSON(requestParameters['sendClientMonthlyReportRequest']),
        };
    }

    /**
     * Queues the activity report of a month (default: previous month) for the configured recipients right away, e.g. to check the settings. The report is created and mailed in the background.
     * Send monthly report now
     */
    async sendClientMonthlyReportRaw(requestParameters: SendClientMonthlyReportOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.sendClientMonthlyReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Queues the activity report of a month (default: previous month) for the configured recipients right away, e.g. to check the settings. The report is created and mailed in the background.
     * Send monthly report now
     */
    async sendClientMonthlyReport(clientUUID: string, sendClientMonthlyReportRequest: SendClientMonthlyReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.sendClientMonthlyReportRaw({ clientUUID: clientUUID, sendClientMonthlyReportRequest: sendClientMonthlyReportRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sendFileLog without sending the request
     */
    async sendFileLogRequestOpts(requestParameters: SendFileLogRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling sendFileLog().'
            );
        }

        if (requestParameters['logName'] == null) {
            throw new runtime.RequiredError(
                'logName',
                'Required parameter "logName" was null or undefined when calling sendFileLog().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuthCollector authentication
        }


        let urlPath = `/client/{clientUUID}/collector/log/{logName}`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));
        urlPath = urlPath.replace('{logName}', encodeURIComponent(String(requestParameters['logName'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Upload log files to client (used for debugging) for collector
     */
    async sendFileLogRaw(requestParameters: SendFileLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.sendFileLogRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Upload log files to client (used for debugging) for collector
     */
    async sendFileLog(clientUUID: string, logName: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.sendFileLogRaw({ clientUUID: clientUUID, logName: logName }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setClientRef without sending the request
     */
    async setClientRefRequestOpts(requestParameters: SetClientRefOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling setClientRef().'
            );
        }

        if (requestParameters['setClientRefRequest'] == null) {
            throw new runtime.RequiredError(
                'setClientRefRequest',
                'Required parameter "setClientRefRequest" was null or undefined when calling setClientRef().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/clientRef`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetClientRefRequestToJSON(requestParameters['setClientRefRequest']),
        };
    }

    /**
     * Sets or clears the custom reference identifier for this client. Use this to link the client record to an external system (e.g. a CRM ID). Set to `null` to remove the reference.
     * Set client reference
     */
    async setClientRefRaw(requestParameters: SetClientRefOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.setClientRefRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Sets or clears the custom reference identifier for this client. Use this to link the client record to an external system (e.g. a CRM ID). Set to `null` to remove the reference.
     * Set client reference
     */
    async setClientRef(clientUUID: string, setClientRefRequest: SetClientRefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.setClientRefRaw({ clientUUID: clientUUID, setClientRefRequest: setClientRefRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setContactDetails without sending the request
     */
    async setContactDetailsRequestOpts(requestParameters: SetContactDetailsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling setContactDetails().'
            );
        }

        if (requestParameters['setContactDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'setContactDetailsRequest',
                'Required parameter "setContactDetailsRequest" was null or undefined when calling setContactDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/contact`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetContactDetailsRequestToJSON(requestParameters['setContactDetailsRequest']),
        };
    }

    /**
     * Updates the admin and emergency contact information for this client.
     * Update contact details
     */
    async setContactDetailsRaw(requestParameters: SetContactDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.setContactDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the admin and emergency contact information for this client.
     * Update contact details
     */
    async setContactDetails(clientUUID: string, setContactDetailsRequest: SetContactDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setContactDetailsRaw({ clientUUID: clientUUID, setContactDetailsRequest: setContactDetailsRequest }, initOverrides);
    }

    /**
     * Creates request options for setEmployeeCount without sending the request
     */
    async setEmployeeCountRequestOpts(requestParameters: SetEmployeeCountOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling setEmployeeCount().'
            );
        }

        if (requestParameters['setEmployeeCountRequest'] == null) {
            throw new runtime.RequiredError(
                'setEmployeeCountRequest',
                'Required parameter "setEmployeeCountRequest" was null or undefined when calling setEmployeeCount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/employeeCount`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetEmployeeCountRequestToJSON(requestParameters['setEmployeeCountRequest']),
        };
    }

    /**
     * **Deprecated** as of new pricing (06.2026). Sets the reported employee count for this client, used for legacy seat-based billing.
     * Set employee count
     */
    async setEmployeeCountRaw(requestParameters: SetEmployeeCountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.setEmployeeCountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * **Deprecated** as of new pricing (06.2026). Sets the reported employee count for this client, used for legacy seat-based billing.
     * Set employee count
     */
    async setEmployeeCount(clientUUID: string, setEmployeeCountRequest: SetEmployeeCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.setEmployeeCountRaw({ clientUUID: clientUUID, setEmployeeCountRequest: setEmployeeCountRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateClientMonthlyReportSettings without sending the request
     */
    async updateClientMonthlyReportSettingsRequestOpts(requestParameters: UpdateClientMonthlyReportSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling updateClientMonthlyReportSettings().'
            );
        }

        if (requestParameters['getClientMonthlyReportSettings200Response'] == null) {
            throw new runtime.RequiredError(
                'getClientMonthlyReportSettings200Response',
                'Required parameter "getClientMonthlyReportSettings200Response" was null or undefined when calling updateClientMonthlyReportSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/report/monthly/settings`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GetClientMonthlyReportSettings200ResponseToJSON(requestParameters['getClientMonthlyReportSettings200Response']),
        };
    }

    /**
     * Enables or disables the automatic monthly activity report mail and sets its recipients.
     * Update monthly report settings
     */
    async updateClientMonthlyReportSettingsRaw(requestParameters: UpdateClientMonthlyReportSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClientMonthlyReportSettings200Response>> {
        const requestOptions = await this.updateClientMonthlyReportSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClientMonthlyReportSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * Enables or disables the automatic monthly activity report mail and sets its recipients.
     * Update monthly report settings
     */
    async updateClientMonthlyReportSettings(clientUUID: string, getClientMonthlyReportSettings200Response: GetClientMonthlyReportSettings200Response, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClientMonthlyReportSettings200Response> {
        const response = await this.updateClientMonthlyReportSettingsRaw({ clientUUID: clientUUID, getClientMonthlyReportSettings200Response: getClientMonthlyReportSettings200Response }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateIoe without sending the request
     */
    async updateIoeRequestOpts(requestParameters: UpdateIoeOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling updateIoe().'
            );
        }

        if (requestParameters['ioeId'] == null) {
            throw new runtime.RequiredError(
                'ioeId',
                'Required parameter "ioeId" was null or undefined when calling updateIoe().'
            );
        }

        if (requestParameters['updateIoeRequest'] == null) {
            throw new runtime.RequiredError(
                'updateIoeRequest',
                'Required parameter "updateIoeRequest" was null or undefined when calling updateIoe().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/ioe/{ioeId}`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));
        urlPath = urlPath.replace('{ioeId}', encodeURIComponent(String(requestParameters['ioeId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateIoeRequestToJSON(requestParameters['updateIoeRequest']),
        };
    }

    /**
     * Updates the disabled/exception state of an IoE finding. Set `is_disabled` to `true` to suppress a finding (e.g. because it is a known accepted risk), and provide a reason and comment. Set `is_disabled` to `false` to re-enable it.
     * Update IoE finding
     */
    async updateIoeRaw(requestParameters: UpdateIoeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.updateIoeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Updates the disabled/exception state of an IoE finding. Set `is_disabled` to `true` to suppress a finding (e.g. because it is a known accepted risk), and provide a reason and comment. Set `is_disabled` to `false` to re-enable it.
     * Update IoE finding
     */
    async updateIoe(clientUUID: string, ioeId: string, updateIoeRequest: UpdateIoeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.updateIoeRaw({ clientUUID: clientUUID, ioeId: ioeId, updateIoeRequest: updateIoeRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateIoeException without sending the request
     */
    async updateIoeExceptionRequestOpts(requestParameters: UpdateIoeExceptionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling updateIoeException().'
            );
        }

        if (requestParameters['ioeKey'] == null) {
            throw new runtime.RequiredError(
                'ioeKey',
                'Required parameter "ioeKey" was null or undefined when calling updateIoeException().'
            );
        }

        if (requestParameters['updateIoeExceptionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateIoeExceptionRequest',
                'Required parameter "updateIoeExceptionRequest" was null or undefined when calling updateIoeException().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/ioe/config/{ioeKey}/exception`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));
        urlPath = urlPath.replace('{ioeKey}', encodeURIComponent(String(requestParameters['ioeKey'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateIoeExceptionRequestToJSON(requestParameters['updateIoeExceptionRequest']),
        };
    }

    /**
     * Sets or removes an exception on an IoE itself. Only possible for IoEs without object findings (e.g. a missing domain or GPO setting); IoEs with object findings are excepted per finding via `updateIoe`. An excepted IoE no longer counts in the security score.
     * Update IoE exception
     */
    async updateIoeExceptionRaw(requestParameters: UpdateIoeExceptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.updateIoeExceptionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Sets or removes an exception on an IoE itself. Only possible for IoEs without object findings (e.g. a missing domain or GPO setting); IoEs with object findings are excepted per finding via `updateIoe`. An excepted IoE no longer counts in the security score.
     * Update IoE exception
     */
    async updateIoeException(clientUUID: string, ioeKey: UpdateIoeExceptionOperationIoeKeyEnum, updateIoeExceptionRequest: UpdateIoeExceptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.updateIoeExceptionRaw({ clientUUID: clientUUID, ioeKey: ioeKey, updateIoeExceptionRequest: updateIoeExceptionRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for validateEntraConnection without sending the request
     */
    async validateEntraConnectionRequestOpts(requestParameters: ValidateEntraConnectionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling validateEntraConnection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/entra/validate`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Tests the current Entra ID (Azure AD) integration for this client by attempting to authenticate with the configured credentials. Returns success if the connection is working.
     * Validate Entra ID connection
     */
    async validateEntraConnectionRaw(requestParameters: ValidateEntraConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.validateEntraConnectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Tests the current Entra ID (Azure AD) integration for this client by attempting to authenticate with the configured credentials. Returns success if the connection is working.
     * Validate Entra ID connection
     */
    async validateEntraConnection(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.validateEntraConnectionRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetClientMonthlyReportFormatEnum = {
    Pdf: 'pdf',
    Csv: 'csv',
} as const;
export type GetClientMonthlyReportFormatEnum = typeof GetClientMonthlyReportFormatEnum[keyof typeof GetClientMonthlyReportFormatEnum];
/**
 * @export
 */
export const GetCollectorSbomComponentEnum = {
    Collector: 'collector',
    Installer: 'installer',
} as const;
export type GetCollectorSbomComponentEnum = typeof GetCollectorSbomComponentEnum[keyof typeof GetCollectorSbomComponentEnum];
/**
 * @export
 */
export const UpdateIoeExceptionOperationIoeKeyEnum = {
    AdRecycleBinNotEnabled: 'ad-recycle-bin-not-enabled',
    BreakGlassAccountUsed: 'break-glass-account-used',
    ComputerCantChangePassword: 'computer-cant-change-password',
    ComputerDcInactive: 'computer-dc-inactive',
    ComputerDcPasswordTooOld: 'computer-dc-password-too-old',
    ComputerDcWrongOwner: 'computer-dc-wrong-owner',
    ComputerDcWrongPrimaryGroup: 'computer-dc-wrong-primary-group',
    ComputerDcNoConstrainedDelegation: 'computer-dc-no-constrained-delegation',
    ComputerDcNoRedundancy: 'computer-dc-no-redundancy',
    ComputerWrongPrimaryGroup: 'computer-wrong-primary-group',
    ComputerEolOsDetected: 'computer-eol-os-detected',
    ComputerInactiveEnabled: 'computer-inactive-enabled',
    ComputerPasswordNotRequired: 'computer-password-not-required',
    ComputerPasswordNeverExpires: 'computer-password-never-expires',
    ComputerNativeAdminManagement: 'computer-native-admin-management',
    ComputerPasswordTooOld: 'computer-password-too-old',
    ComputerSmbv1DcSupported: 'computer-smbv1-dc-supported',
    ComputerSmbv1Supported: 'computer-smbv1-supported',
    ComputerUnconstrainedDelegation: 'computer-unconstrained-delegation',
    ComputerDcUpdateRequired: 'computer-dc-update-required',
    CountDomainAdmins: 'count-domain-admins',
    DefaultAdminGroupsUsed: 'default-admin-groups-used',
    DesAllowed: 'des-allowed',
    DomainFunctionLevel: 'domain-function-level',
    DomainAdminSdHolderProtectionDisabled: 'domain-admin-sd-holder-protection-disabled',
    DomainUnauthorizedDcsyncPermissions: 'domain-unauthorized-dcsync-permissions',
    DomainDsheuristicsAnonymousNspiAllowed: 'domain-dsheuristics-anonymous-nspi-allowed',
    DomainDsheuristicsForestAnonymousAccess: 'domain-dsheuristics-forest-anonymous-access',
    DomainDsheuristicsUpnAndSpnNotUnique: 'domain-dsheuristics-upn-and-spn-not-unique',
    DomainDsheuristicsLdapSecurity: 'domain-dsheuristics-ldap-security',
    DomainDsheuristicsDolistObject: 'domain-dsheuristics-dolist-object',
    DomainLdapSigningNotRequired: 'domain-ldap-signing-not-required',
    DomainLdapsChannelBindingNotRequired: 'domain-ldaps-channel-binding-not-required',
    EntraLegacyAuthenticationAllowed: 'entra-legacy-authentication-allowed',
    EntraNoDeviceComplianceConditionalAccess: 'entra-no-device-compliance-conditional-access',
    EntraAllCloudAppsAllUsersConditionalAccess: 'entra-all-cloud-apps-all-users-conditional-access',
    EntraSecurityDefaultsNotEnabled: 'entra-security-defaults-not-enabled',
    EntraRecommendationDesignateMoreThanOneGlobalAdmin: 'entra-recommendation-designate-more-than-one-global-admin',
    EntraConditionalAccessPolicyExcludesEmergencyAccount: 'entra-conditional-access-policy-excludes-emergency-account',
    EntraConditionalAccessNoMfaForAdmins: 'entra-conditional-access-no-mfa-for-admins',
    EntraConditionalAccessReferencesDeletedGroup: 'entra-conditional-access-references-deleted-group',
    EntraDynamicGroupMemberofRule: 'entra-dynamic-group-memberof-rule',
    EntraConditionalAccessNoMfaForAllUsers: 'entra-conditional-access-no-mfa-for-all-users',
    EntraConditionalAccessNoMfaForAzureManagement: 'entra-conditional-access-no-mfa-for-azure-management',
    EntraConditionalAccessExchangeActivesyncNotBlocked: 'entra-conditional-access-exchange-activesync-not-blocked',
    EntraConditionalAccessSecurityInfoRegistrationUnprotected: 'entra-conditional-access-security-info-registration-unprotected',
    EntraConditionalAccessNoManagedDeviceForAdmins: 'entra-conditional-access-no-managed-device-for-admins',
    EntraConditionalAccessUnknownPlatformsNotBlocked: 'entra-conditional-access-unknown-platforms-not-blocked',
    EntraConditionalAccessNoMfaForGuests: 'entra-conditional-access-no-mfa-for-guests',
    EntraConditionalAccessNoAppEnforcedRestrictions: 'entra-conditional-access-no-app-enforced-restrictions',
    EntraConditionalAccessDeviceCodeFlowNotBlocked: 'entra-conditional-access-device-code-flow-not-blocked',
    EntraConditionalAccessRiskConditionsCombined: 'entra-conditional-access-risk-conditions-combined',
    EntraHybridUserPermanentRoleInControlPlane: 'entra-hybrid-user-permanent-role-in-control-plane',
    EntraExternalUserPermanentRoleInControlPlane: 'entra-external-user-permanent-role-in-control-plane',
    EntraConditionalAccessAllCloudApps: 'entra-conditional-access-all-cloud-apps',
    EntraPrivilegedOnpremUserSynced: 'entra-privileged-onprem-user-synced',
    EntraPrivilegedUserInactive: 'entra-privileged-user-inactive',
    ForestFunctionLevel: 'forest-function-level',
    GpoLanmanagerEnabled: 'gpo-lanmanager-enabled',
    GpoContainsPassword: 'gpo-contains-password',
    GpoWeakPasswordPolicy: 'gpo-weak-password-policy',
    GpoRegAutologin: 'gpo-reg-autologin',
    GpoNtlmv1DcEnabled: 'gpo-ntlmv1-dc-enabled',
    GpoDangerousPrivilegeEveryone: 'gpo-dangerous-privilege-everyone',
    GpoFilesModifiable: 'gpo-files-modifiable',
    GpoNtlmv1Enabled: 'gpo-ntlmv1-enabled',
    GpoWsusCertificatePinningDisabled: 'gpo-wsus-certificate-pinning-disabled',
    GpoKerberosArmoringSupported: 'gpo-kerberos-armoring-supported',
    GpoLdapSigningDisabled: 'gpo-ldap-signing-disabled',
    GpoDenyComputerPasswordChange: 'gpo-deny-computer-password-change',
    GpoAdminRecoveryLoginEnabled: 'gpo-admin-recovery-login-enabled',
    GpoPowershellLoggingDisabled: 'gpo-powershell-logging-disabled',
    GpoTrustedCredmanAccessPrivilege: 'gpo-trusted-credman-access-privilege',
    GpoWritableByNonPrivilegedUsers: 'gpo-writable-by-non-privileged-users',
    GpoLegacyLaps: 'gpo-legacy-laps',
    GpoWsusHttp: 'gpo-wsus-http',
    GpoHardenedUncPathsDisabled: 'gpo-hardened-unc-paths-disabled',
    GpoUnlinkedOrDisabled: 'gpo-unlinked-or-disabled',
    GroupSchemaAdminsNotEmpty: 'group-schema-admins-not-empty',
    GroupNoMember: 'group-no-member',
    GroupRodcNotEmpty: 'group-rodc-not-empty',
    GroupDeniedRodcDefaultMembers: 'group-denied-rodc-default-members',
    GroupOperatorNotEmpty: 'group-operator-not-empty',
    GroupPrewin2000Anonymous: 'group-prewin2000-anonymous',
    GroupPrewin2000Authenticated: 'group-prewin2000-authenticated',
    KdcPasswordChange: 'kdc-password-change',
    KerberosAesDisabledServiceaccounts: 'kerberos-aes-disabled-serviceaccounts',
    NonAdminHasAdmincount: 'non-admin-has-admincount',
    ObjectDuplicatedSamaccountname: 'object-duplicated-samaccountname',
    OuNotProtected: 'ou-not-protected',
    OuNonDefaultTrustee: 'ou-non-default-trustee',
    OuTooWidePermissions: 'ou-too-wide-permissions',
    OuDangerousPermissions: 'ou-dangerous-permissions',
    PamFeatureNotEnabled: 'pam-feature-not-enabled',
    PrivilegedUserDeactivated: 'privileged-user-deactivated',
    PrivilegedUserCanBeDelegated: 'privileged-user-can-be-delegated',
    PrivilegedUserDesAllowed: 'privileged-user-des-allowed',
    PrivilegedUserConstrainedDelegation: 'privileged-user-constrained-delegation',
    PrivilegedUserInactive: 'privileged-user-inactive',
    PrivilegedUserEmailEnabled: 'privileged-user-email-enabled',
    PasswordLikeStringFound: 'password-like-string-found',
    PrivilegedUserHasSpn: 'privileged-user-has-spn',
    PrivilegedUserNotInProtecteduserGroup: 'privileged-user-not-in-protecteduser-group',
    PrivilegedUserPasswordReversible: 'privileged-user-password-reversible',
    UserAddComputerToDomainAllowed: 'user-add-computer-to-domain-allowed',
    UserCantChangePassword: 'user-cant-change-password',
    UserConstrainedDelegation: 'user-constrained-delegation',
    UserEmptyPasswordAllowed: 'user-empty-password-allowed',
    UserInactiveEnabledAccounts: 'user-inactive-enabled-accounts',
    UserLastPasswordChange: 'user-last-password-change',
    UserPasswordNeverExpires: 'user-password-never-expires',
    UserPasswordReversible: 'user-password-reversible',
    UserGuestEnabled: 'user-guest-enabled',
    UserGuestWrongPrimaryGroup: 'user-guest-wrong-primary-group',
    UserPreauthNotRequired: 'user-preauth-not-required',
    UserUnconstrainedDelegation: 'user-unconstrained-delegation',
    UserWrongPrimaryGroup: 'user-wrong-primary-group',
    UserPasswordAttributesNotEmpty: 'user-password-attributes-not-empty',
} as const;
export type UpdateIoeExceptionOperationIoeKeyEnum = typeof UpdateIoeExceptionOperationIoeKeyEnum[keyof typeof UpdateIoeExceptionOperationIoeKeyEnum];
